"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appleProxyApiClient = void 0;
const data_lib_1 = require("@redbox-ruby/data-lib");
const utils_1 = require("./utils");
function appleProxyApiClient(networkClient) {
    return {
        searchForiOSApp: (platformOrgId, query) => {
            return networkClient.getHttp(data_lib_1.APPLE_PROXY_WEB_SERVICE, `/api/v2/apple-proxy/search/apps`, query, { headers: (0, utils_1.getOrgIdHeaders)(platformOrgId) });
        },
        lookupApplicationFromAppleSearch: (params) => {
            return networkClient.getHttp(data_lib_1.APPLE_PROXY_WEB_SERVICE, `/api/v2/apple-proxy/app-search/id/${params.id}`);
        },
        findApplicationFromAppleSearch: (query) => {
            return networkClient.getHttp(data_lib_1.APPLE_PROXY_WEB_SERVICE, `/api/v2/apple-proxy/app-search/find`, query);
        },
        lookupApplicationFromAppleiTunes: (params, query) => {
            return networkClient.getHttp(data_lib_1.APPLE_PROXY_WEB_SERVICE, `/api/v2/apple-proxy/apple-itunes/id/${params.id}`, query);
        },
        createApplicationFromAppleiTunes: (params, body) => {
            return networkClient.postHttp(data_lib_1.APPLE_PROXY_WEB_SERVICE, `/api/v2/apple-proxy/apple-itunes/id/${params.id}`, body);
        },
        findApplicationFromAppleiTunes: (query) => {
            return networkClient.getHttp(data_lib_1.APPLE_PROXY_WEB_SERVICE, `/api/v2/apple-proxy/apple-itunes/find`, query);
        },
        findGeolocations: async (platformOrgId, query) => {
            return networkClient.getHttp(data_lib_1.APPLE_PROXY_WEB_SERVICE, `/api/v2/apple-proxy/search/geo`, query, { headers: (0, utils_1.getOrgIdHeaders)(platformOrgId) });
        },
    };
}
exports.appleProxyApiClient = appleProxyApiClient;
